import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createEventUserService } from "../../api/userService";
import { UserSelectOption } from "./UserSelectOption";

interface Props {
	eventId: Id;
	name: string;
	label: string;
}

export const EventUserMultiSelect: FC<Props> = ({ eventId, name, label }) => {
	const eventUserService = useMemo(() => createEventUserService(eventId), [eventId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			fetchConfig={laravelSelectFetchConfig(eventUserService.getAvailableUsersKey, (search, page) =>
				eventUserService.getAvailableUsers(search, page).then((r) => r.data),
			)}
			required={true}
			renderOption={(x, isSelected) => <UserSelectOption isSelected={isSelected} user={x} />}
		/>
	);
};
